import { useSearchParams } from "react-router-dom"
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import { ProductCatalog } from "@/components/catalog/ProductCatalog"
import { useLanguage } from "@/hooks/useLanguage"
import { SEO } from "@/components/SEO"
import { ConsumptionType } from "@/api/api-client"

type LocaleKey = "general" | "industrial" | "human_consumption"

const toLocaleKey = (type?: ConsumptionType): LocaleKey => {
  if (type === ConsumptionType.Industrial) return "industrial"
  if (type === ConsumptionType.Human) return "human_consumption"
  return "general"
}

interface ProductMarketplaceProps {
  consumptionType?: ConsumptionType
}

const ProductMarketplace = ({ consumptionType }: ProductMarketplaceProps) => {
  const { t } = useLanguage()
  const [searchParams] = useSearchParams()
  const initialSearchTerm = searchParams.get("q") ?? ""

  const text = t.productMarketplace[toLocaleKey(consumptionType)]

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground transition-colors duration-300">
      <SEO title={t.seo.catalogTitle} description={t.seo.catalogDesc} />
      <Header />

      <main className="flex-1 pb-20 pt-24">
        <div className="container mx-auto px-4">
          <div className="mb-16 space-y-4 text-center">
            <h1 className="font-display text-5xl uppercase leading-none tracking-tighter text-primary md:text-7xl">
              {text.title}
            </h1>
            <div className="mx-auto h-1 w-12 bg-primary" />
            <p className="mx-auto max-w-2xl text-lg font-bold tracking-label text-muted-foreground">
              {text.subtitle}
            </p>
          </div>

          <ProductCatalog consumptionType={consumptionType} initialSearchTerm={initialSearchTerm} />
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default ProductMarketplace
